import Vue from "vue";
import assert from "assert";
import { newContainer } from "@/utils";
import { type } from "jquery";

const $doc = $(document);

export function setUpReportUser() {
  function onClick(this: HTMLElement) {
    const $this = $(this);
    const userId = $this.data("userid");
    const userName = $this.data("username");
    assert(userId, "userId falsy");
    assert(userName, "userName falsy");
    const ReportUser = () => import(/* webpackChunkName: "ReportUser" */ "./ReportUser.vue");
    new Vue({
      render: (h) =>
        h(ReportUser, {
          props: {
            userId,
            userName,
          },
        }),
    }).$mount(newContainer());
  }
  $doc.on("click", ".js-report-user", onClick);
  return () => $doc.off("click", ".js-report-user", onClick);
}

export function setUpReportTopicPost() {
  function onClick(this: HTMLElement) {
    const $this = $(this);
    const topicPostId = $this.data("topicpostid");
    const title = $this.data("title");
    assert(topicPostId, "topicpostId falsy");
    assert(title, "title falsy");
    const ReportTopicPost = () => import(/* webpackChunkName: "ReportUser" */ "./ReportTopicPost.vue");
    new Vue({
      render: (h) =>
        h(ReportTopicPost, {
          props: {
            topicPostId,
            title,
          },
        }),
    }).$mount(newContainer());
  }
  $doc.on("click", ".js-report-topicpost", onClick);
  return () => $doc.off("click", ".js-report-topicpost", onClick);
}
 

export function setUpReportProduct() {
  function onClick(this: HTMLElement) {
    const $this = $(this);
    const productId = $this.data("productid");
    const title = $this.data("title");
    assert(productId, "productid falsy");
    assert(title, "title falsy");
    const ReportProduct = () => import(/* webpackChunkName: "ReportUser" */ "./ReportProduct.vue");
    new Vue({
      render: (h) =>
        h(ReportProduct, {
          props: {
            productId,
            title,
          },
        }),
    }).$mount(newContainer());
  }
  $doc.on("click", ".js-report-product", onClick);
  return ()=> $doc.off("click", ".js-report-product", onClick);
}

export function setUpReportCompany() {
  function onClick(this: HTMLElement) {
    const $this = $(this);
    const companyId = $this.data("companyid");
    const name = $this.data("name");
    assert(companyId, "companyId falsy");
    assert(name, "name falsy");
    const ReportCompany = () => import(/* webpackChunkName: "ReportUser" */ "./ReportCompany.vue");
    new Vue({
      render: (h) =>
        h(ReportCompany, {
          props: {
            companyId,
            name,
          },
        }),
    }).$mount(newContainer());
  }
  $doc.on("click", ".js-report-company", onClick);
  return () => $doc.off("click", ".js-report-company", onClick);
}
